import { createSlice } from "@reduxjs/toolkit";

const initialStateList = {
  isTableFullScreen: false,
  isSideBarOpen: true,
  isLeadFormOpen: false,
  isToDoTaskModalOpen: false,
  isReminderModalOpen: false,
  selectedStudent: null,
  activeApplicationTab: "messages", // Add the new state for active tab
};

const applicationSlice = createSlice({
  name: "application",
  initialState: initialStateList,

  reducers: {
    setSelectedStudent(state, action) {
      state.selectedStudent = action.payload;
    },
    toggleFinalizationStatus(state, action) {
      if (state.selectedStudent) {
        state.selectedStudent.is_finalised = action.payload;
      }
    },
    toggleFullScreen: (state, action) => {
      state.isTableFullScreen = !state.isTableFullScreen;
    },
    toggleSideBar: (state, action) => {
      // state.isTableFullScreen = !state.isTableFullScreen;
      state.isSideBarOpen = !state.isSideBarOpen;
    },
    toggleLeadFormOpen: (state, action) => {
      state.isLeadFormOpen = !state.isLeadFormOpen;
    },
    toggleToDoTaskModal: (state, action) => {
      state.isToDoTaskModalOpen = action.payload;
    },
    toggleReminderModal: (state, action) => {
      state.isReminderModalOpen = action.payload;
    },
    // Add new reducer for active tab
    setActiveApplicationTab: (state, action) => {
      state.activeApplicationTab = action.payload;
    },
  },
});

export const {
  toggleFullScreen,
  toggleSideBar,
  toggleLeadFormOpen,
  toggleToDoTaskModal,
  toggleReminderModal,
  setSelectedStudent,
  toggleFinalizationStatus,
  setActiveApplicationTab, // Export the new action
} = applicationSlice.actions;

export default applicationSlice.reducer;
